import { Component, OnInit } from '@angular/core';
import { UpdateService } from '@core/service/update.service';
import { MessagingService } from '@core/service/messaging.service';
import { Observable } from 'rxjs';
import { ConfiguracionService } from './core/service/configuracion.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  message: Observable<any>;
  constructor(private configuracionService: ConfiguracionService) {}
  // constructor(public updateService: UpdateService, private messagingService: MessagingService) {
  // public updates: SwUpdate,
  /*  updates.available.subscribe(event => {
        console.log('current version is', event.current);
        console.log('available version is', event.available);
      });
      updates.activated.subscribe(event => {
        console.log('old version was', event.previous);
        console.log('new version is', event.current);
      });

      updates.available.subscribe(event => {
        console.log(event);
        updates.activateUpdate().then(() => this.updateApp());
      });*/
  // }

  updateApp() {
    document.location.reload();
    console.log('The app is updating right now');
  }
  ngOnInit() {
    /*   this.messagingService.requestPermission();
    this.messagingService.receiveMessage();

    this.message = this.messagingService.currentMessage;*/
  }
}
